import { initializeClock } from '../utils/_countdown'
const $ = jQuery

export default function OfferCounter () {
  const OFFER_COUNTER = document.querySelectorAll('[data-offer-endtime]')
  const offerViewCounters = document.querySelectorAll('.offer-product-card__view-count')
  const offerViewCountersArray = Array.from(offerViewCounters)
  const stockCounters = document.getElementsByClassName('offer-product-card__stock-count')

  if (OFFER_COUNTER.length > 0) {
    const clock = OFFER_COUNTER[0].querySelector('.mtt-products__clock')
    const endDate = OFFER_COUNTER[0].getAttribute('data-offer-endtime')

    if (endDate) {
      initializeClock(clock, new Date(endDate.replace(/-/g, "/")), () => $(OFFER_COUNTER).remove())
    }
  }

  if (offerViewCountersArray.length > 0) {
    for (let i = 0; i < offerViewCountersArray.length; i++) {
      let randomNumber = Math.floor(Math.random() * 10) + 1;
      const viewCounterSpan = offerViewCountersArray[i].getElementsByTagName('SPAN')

      if(randomNumber === 1) {
        $(viewCounterSpan).append(randomNumber + ' ' + offerViewCountersArray[i].dataset.singleView)
      } else {
        $(viewCounterSpan).append(randomNumber + ' ' + offerViewCountersArray[i].dataset.multipleView)
      }
    }
  }

  if (stockCounters.length > 0) {
    setTimeout( () => {
      $(stockCounters).fadeIn('fast').animate({
        'top': '264px'
      }, {duration: 'slow', queue: false}, function() {
        // Animation complete.
      });

      $(stockCounters).css('display', 'flex')
    }, 3000)
  }

  if (offerViewCounters.length >0) {
    setTimeout( () => {
      $(offerViewCounters).fadeIn('fast').animate({
        'top': '304px'
      }, {duration: 'slow', queue: false}, function() {
        // Animation complete.
      });

      $(offerViewCounters).css('display', 'flex')
    }, 4000)
  }
}
